export enum TooltipStyle {
  default = 'default',
  dark = 'dark',
  darkRounded = 'dark-rounded',
}
